import HoroscopeBlock from "@blocks/Horoscope/HoroscopeBlock";

export const HoroscopeSection = () => {
  return (
    <div className="mt-md pb-md border-b border-pink-300">
      <HoroscopeBlock />
    </div>
  );
};
